import { html, nothing } from "lit";
import { stripOperatorInjectDisplayText } from "../../../../src/chat/transcript-filters.js";
import type { RunTimelineEntry } from "../operator-trust/state.ts";

export type ChatRunTimelineProps = {
  entries: RunTimelineEntry[];
  limit?: number;
  title?: string;
};

function formatAge(atMs: number): string {
  const sec = Math.max(0, Math.floor((Date.now() - atMs) / 1000));
  if (sec < 60) {
    return `${sec}s ago`;
  }
  const min = Math.floor(sec / 60);
  if (min < 60) {
    return `${min}m ago`;
  }
  return `${Math.floor(min / 60)}h ago`;
}

export function renderChatRunTimeline(props: ChatRunTimelineProps) {
  const limit = props.limit ?? 8;
  const rows = props.entries.slice(0, limit);
  if (rows.length === 0) {
    return nothing;
  }
  return html`
    <section class="chat-run-timeline" aria-label="Run timeline">
      <header class="chat-run-timeline__head">
        <span>${props.title ?? "Run timeline"}</span>
      </header>
      <ol class="chat-run-timeline__list">
        ${rows.map(
          (entry) => html`
            <li class="chat-run-timeline__item">
              <span class="chat-run-timeline__time mono">${formatAge(entry.atMs)}</span>
              <div class="chat-run-timeline__body">
                <span class="chat-run-timeline__summary"
                  >${stripOperatorInjectDisplayText(entry.summary)}</span
                >
                ${
                  entry.detail
                    ? html`<span class="chat-run-timeline__detail muted"
                        >${stripOperatorInjectDisplayText(entry.detail)}</span
                      >`
                    : nothing
                }
              </div>
            </li>
          `,
        )}
      </ol>
    </section>
  `;
}
